import {UserOrganization} from "../model/types";

type SortUsersProps = {
  users: UserOrganization[];
  sortColumn: string;
  sortOrder: "asc" | "desc";
};

export const sortUsers = ({users, sortColumn, sortOrder}: SortUsersProps) => {
  return users.sort((a, b) => {
    if (!sortColumn) return 0;
    const valueA = a[sortColumn];
    const valueB = b[sortColumn];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return sortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }
    return 0;
  });
};
